import Vue from 'vue'
import Vuetify from 'vuetify/lib'

Vue.use(Vuetify)

// MWU Brand Colors
// Primary: Black (#1A1A1A) - for CTAs and selected states
// Secondary: Brand Green (#B8BA9E) - for active status and accents

export default new Vuetify({
  icons: {
    iconfont: 'mdiSvg',
  },
  theme: {
    options: {
      customProperties: true,
    },
    themes: {
      light: {
        primary: {
          base: '#1A1A1A',
          lighten1: '#404040',
          lighten2: '#666666',
          lighten3: '#8C8C8C',
          lighten4: '#E8E8E8',
          darken1: '#141414',
          darken2: '#0D0D0D',
          darken3: '#080808',
          darken4: '#050505',
          darken5: '#000000',
        },
        secondary: '#B8BA9E',
        accent: '#B8BA9E',
        success: '#B8BA9E',
        error: '#c21e51',
        grey: {
          base: '#9E9E9E',
          lighten3: '#f1f3f4',
        },
      },
    },
  },
})
